<template>
  <div class="value-range">
    <div class="inputs">
      <el-input v-model="startValue" v-bind="$attrs"></el-input>
      <span>&ensp;-&ensp;</span>
      <el-input v-model="endValue" v-bind="$attrs"></el-input>
      <slot name="suffix"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  computed: {
    startValue: {
      get() {
        return this.value[0]
      },
      set(val) {
        this.$emit('input', [val, this.endValue])
      }
    },
    endValue: {
      get() {
        return this.value[1]
      },
      set(val) {
        this.$emit('input', [this.startValue, val])
      }
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.value-range {
  .inputs {
    display: flex;
    align-items: center;
    .el-input {
      width: 160px;
    }
  }
  &-suffix {
    margin-left: 5px;
  }
}
</style>
